import { Reveal } from "./Reveal";

export const Problem = () => (
    <section
        id="problem"
        data-testid="problem-narrative-section"
        className="px-5 py-24 sm:px-8 sm:py-36"
    >
        <div className="mx-auto grid max-w-[1500px] gap-12 lg:grid-cols-12">
            <div className="lg:col-span-5">
                <Reveal>
                    <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#C7B7FF]">
                        The problem
                    </p>
                    <h2 className="mt-6 text-2xl font-semibold leading-tight tracking-tight text-[#F4F1EC] sm:text-4xl lg:text-5xl">
                        Finding people shouldn't feel this random.
                    </h2>
                </Reveal>
            </div>
            <div className="lg:col-span-6 lg:col-start-7">
                <Reveal delay={0.1}>
                    <p className="text-base leading-relaxed text-[#C9C5C0] sm:text-lg">
                        The people you would genuinely find interesting may already exist nearby —
                        or somewhere else in the world. But most social and dating apps give you
                        very little meaningful information to discover them through.
                    </p>
                    <p className="mt-6 text-base leading-relaxed text-[#C9C5C0] sm:text-lg">
                        Profiles are often shallow. Interests are decorative. Discovery is dominated
                        by appearance, popularity or endless swiping.
                    </p>
                    <p className="mt-6 text-base leading-relaxed text-[#C9C5C0] sm:text-lg">
                        Discovery starts from a different question:
                    </p>
                    <blockquote className="font-serif2 mt-10 border-l-2 border-[#C7B7FF] pl-6 text-2xl italic leading-snug text-[#F4F1EC] sm:text-3xl">
                        “What would actually make me curious about this person?”
                    </blockquote>
                    <p className="font-mono2 mt-12 text-xs uppercase tracking-[0.2em] text-[#C7B7FF]">
                        Less content. More context.
                    </p>
                </Reveal>
            </div>
        </div>
    </section>
);
